const form = {
  formId: "new-company-form",
  formField: {
    id: {
      name: "id",
      label: "رقم الشركة",
      type: "number",
      errorMsg: "رقم الشركة مطلوب.",
    },
    name: {
      name: "name",
      label: "اسم الشركة",
      type: "text",
      errorMsg: "اسم الشركة مطلوب.",
    },
    email: {
      name: "email",
      label: "البريد الإلكتروني",
      type: "email",
      errorMsg: "البريد الإلكتروني مطلوب.",
    },
    website: {
      name: "website",
      label: "الموقع الإلكتروني",
      type: "text",
      errorMsg: "الموقع الإلكتروني مطلوب.",
    },
    description: {
      name: "description",
      label: "الوصف",
      type: "text",
      errorMsg: "الوصف مطلوب.",
    },
    phoneNumber: {
      name: "phoneNumber",
      label: "رقم الهاتف",
      type: "text",
      errorMsg: "رقم الهاتف مطلوب.",
    },
    shortNumber: {
      name: "shortNumber",
      label: "الرقم المختصر",
      type: "text",
      errorMsg: "الرقم المختصر مطلوب.",
    },
    logoUrl: {
      name: "logoUrl",
      label: "الشعار",
      type: "object",
      errorMsg: "الشعار مطلوب.",
    },
    enProfileUrl: {
      name: "enProfileUrl",
      label: "الملف الشخصي باللغة الإنجليزية",
      type: "object",
      errorMsg: "الملف الشخصي باللغة الإنجليزية مطلوب.",
    },
    arProfileUrl: {
      name: "arProfileUrl",
      label: "الملف الشخصي باللغة العربية",
      type: "object",
      errorMsg: "الملف الشخصي باللغة العربية مطلوب.",
    },
  },
};

export default form;
